// extracted by mini-css-extract-plugin
export default {"token":"CreateToken_token__UfWmg"};